export default "__VITE_ASSET__BVQKG0s2__"